
    // TemplateEditor using HugeRTE activeEditor.insertContent
    import { defineComponent, PropType } from "vue";
    import { ITemplate } from "@/Models/Templating/ITemplate";

    import HtmlEditor from "./HtmlEditor.vue";
    import VariableMenu from "./VariableMenu.vue";

    export default defineComponent({
        name: "template-editor",
        components: {
            HtmlEditor,
            VariableMenu,
        },
        emits: ["onChange"],
        props: {
            activeTemplate: {
                type: Object as PropType<ITemplate>,
                required: true,
            },
            includeVariableMenu: {
                type: Boolean,
                required: false,
                default: true,
            },
            includeLabelEditor: {
                type: Boolean,
                required: false,
                default: true,
            },
        },
        created() {
            this.currentTemplate = this.activeTemplate;
        },
        data() {
            return {
                currentTemplate: {} as ITemplate,
            };
        },
        methods: {
            insert(content: string) {
                // HugeRTE is a TinyMCE-style API; activeEditor.insertContent exists.
                // The Vue wrapper loads HugeRTE onto window.hugerte.
                const w = window as any;
                const editor = w.hugerte?.activeEditor;

                if (editor && typeof editor.insertContent === "function") {
                    editor.insertContent(content);
                } else {
                    // Optional: helps diagnose if script isn't loaded yet
                    // console.warn("HugeRTE activeEditor not available yet");
                }

                this.$emit("onChange", this.currentTemplate);
            },
            onChange(text: string) {
				console.log("editor html length:", text?.length);
                this.currentTemplate.contents = text;
                this.$emit("onChange", this.currentTemplate);
            },
        },
        watch: {
            activeTemplate() {
                this.currentTemplate = this.activeTemplate;
            },
        },
    });
